import React from "react";
import { Button } from "@/components/ui/button";

const HeroSection: React.FC = () => (
  <div className="w-full flex flex-col items-center pt-16 pb-20 bg-white px-2">
    {/* Logo + Nav */}
    <div className="w-full max-w-5xl flex justify-between items-center px-6 mb-24">
      <div className="flex items-center">
        <span className="text-3xl font-extrabold text-tx-dark">BRAND</span>
      </div>
      <nav className="flex items-center gap-8 text-tx-dark font-semibold text-base">
        <a href="#" className="hover:text-primary transition">
          Product
        </a>
        <a href="#" className="hover:text-primary transition">
          Customers
        </a>
        <a href="#" className="hover:text-primary transition">
          Pricing
        </a>
        <Button variant="outline" size="sm" className="rounded-full">
          Button Outline
        </Button>
      </nav>
    </div>

    {/* Announcement badge */}
    <div className="flex justify-between gap-3 items-center mb-6 bg-accent-bg-hot text-accent-fg-hot text-sm px-5 py-2 rounded-full">
      <span className="font-bold">New:</span> Infinite Canvas{" "}
      <span className="rounded-sm bg-accent-bg-cold text-accent-fg-cold px-2">
        Learn more
      </span>
    </div>
    {/* Main Headline */}
    <h1 className="text-5xl md:text-7xl font-extrabold text-tx-dark text-center leading-tight mb-6">
      Branding Colors
    </h1>
    {/* Subheading */}
    <p className="text-lg md:text-xl text-tx-default text-center max-w-2xl mb-8">
      Use the colors defined in this page to make sure the pages in every client
      share the same look and feel.
    </p>

    <div className="max-w-sm grid grid-cols-1 sm:grid-cols-2 gap-4">
      <Button variant="primary" size="lg" className="rounded-full">
        Primary Button →
      </Button>

      <Button variant="secondary" size="lg" className="rounded-full  ">
        Secondary Button
      </Button>
    </div>
  </div>
);

export default HeroSection;
